import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/use-auth";
import { I18nProvider } from "@/hooks/use-i18n";
import { OfflineProvider } from "@/hooks/use-offline";
import OfflineBanner from "@/components/OfflineBanner";
import UpdateBanner from "@/components/UpdateBanner";
import HomePage from "./pages/HomePage";
const Index = lazy(() => import("./pages/Index"));
const EventIndex = lazy(() => import("./pages/EventIndex"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const StaffCounterPage = lazy(() => import("./pages/StaffCounterPage"));
const AdminUsersPage = lazy(() => import("./pages/AdminUsersPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const UnsubscribePage = lazy(() => import("./pages/UnsubscribePage"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <I18nProvider>
        <AuthProvider>
          <OfflineProvider>
            <BrowserRouter>
              <UpdateBanner />
              <OfflineBanner />
              <main>
                <Suspense fallback={<div className="min-h-screen" />}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/app" element={<Index />} />
                    <Route path="/app/event/:eventId" element={<EventIndex />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/staff/:token" element={<StaffCounterPage />} />
                    <Route path="/admin/users" element={<AdminUsersPage />} />
                    <Route path="/unsubscribe" element={<UnsubscribePage />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </main>
            </BrowserRouter>
          </OfflineProvider>
        </AuthProvider>
      </I18nProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
